export interface IRejectionReasonDriver {
  id?: string;
  enRejectionReason?: string;
  stRejectionReason?: string;
  countryId?: string;
  rejectionReasonDriverCountryId?: string;
  isActive?: boolean;
}

export const defaultValue: Readonly<IRejectionReasonDriver> = {};
